export class NotificationsApiConverter {
  convertNotifications = (data) => {
    const convertedData = data.notifications.map((item) => ({
      id: item?.id,
      tag: item?.tag?.toLowerCase(),
      text: item?.text,
      date: item?.created_at,
      new: item?.is_new,
      isAuto: item?.is_auto,
    }));

    return convertedData;
  };

  convertNotificationsCount = (data) => data.total;
}
